import Component from '../../Component';
import { createElement } from '../../utils/dom';
import { defaultFilters } from './filters';
import {
	BillData,
	BillDataWithElements,
	billsData,
	DEFAULT_SORT_PARAMS,
	SortParam,
	sortBills,
} from './source';

class BillTrackerList extends Component<HTMLElement> {
	static selector = '.bill-tracker__list';

	currentFilter: (bill: BillData) => boolean = () => true;
	bills: BillData[] = [];
	list?: HTMLUListElement;
	state = {
		billsInView: [],
		visible: false,
		sortParams: DEFAULT_SORT_PARAMS,
	};

	async afterInit() {
		this.bills = (await billsData()).bills;
		this.list = createElement('ul', {
			className: 'bill-tracker__list-container',
		});

		this.element.appendChild(this.list);

		// Initial call
		this.sortList();

		this.emit('init', this);
	}

	clearItems() {
		if (this.list) {
			this.list.innerHTML = '';
		}
	}

	renderBills(bills: BillDataWithElements[]) {
		const fragment = document.createDocumentFragment();

		bills.forEach((bill) => fragment.appendChild(bill.elements.listItem));
		this.list?.append(fragment);

		this.emit('render', this);
	}

	sortList(sortParams: SortParam[] = []) {
		this.setState({ sortParams });
	}

	setFilter(filterFunction?: (bill: BillData) => boolean) {
		this.currentFilter =
			typeof filterFunction === 'function'
				? filterFunction
				: this.currentFilter || (() => true);

		this.updateBillsInView();
	}

	updateBillsInView() {
		const { sortParams } = this.state;

		// Filter bills
		const billsInView = sortBills(
			this.bills.filter(this.currentFilter),
			sortParams
		);

		this.setState({
			billsInView,
		});
	}

	static onBillNameClick(e: PointerEvent) {
		e.preventDefault();

		const url = (e.currentTarget as HTMLButtonElement).getAttribute(
			'data-url'
		);

		if (url) {
			window.open(url, '_blank');
		}
	}

	static generateBillListItemElement(bill: BillData) {
		const billLocalityCode = bill.locality_code.split('-')[1];

		return createElement('li', {
			className: 'bill-tracker__list-item',
			children: [
				createElement('span', {
					className: 'bill-tracker__list-eyebrow',
					innerHTML: `${bill.statusCategory}
					<span class="bill-tracker__table-status-indicator" data-status="${bill.statusCategory?.toLowerCase()}"></span>`,
				}),
				createElement('strong', {
					className: 'bill-tracker__list-title',
					children: [
						createElement('button', {
							attributes: {
								'data-url': bill.source,
							},
							children: [
								createElement('span', {
									textContent: bill.title,
								}),
							],
							events: {
								click: this.onBillNameClick.bind(
									this
								) as EventListener,
							},
						}),
					],
				}),
				createElement('div', {
					className: 'bill-tracker__list-info',
					innerHTML:
						(billLocalityCode
							? `<span class="bill-tracker__list-state">${billLocalityCode}</span>`
							: '') +
						`<span class="bill-tracker__list-number">${bill.primary_external_id}</span>
					<span class="bill-tracker__list-date">${bill.action_date}</span>`,
				}),
			],
		});
	}

	// Re-render the table
	componentDidUpdate(changedStates: Record<string, any>) {
		const { billsInView = [], visible } = this.state || {};

		// Render bills
		if (visible) {
			if ('sortParams' in changedStates) {
				this.updateBillsInView();
			} else {
				this.clearItems();
				this.renderBills(billsInView);
			}
		}
	}
}

export default BillTrackerList;
